const {disabledIntegrationResponse, paypalReady, externalRequestDisabled, joinBase, billingOriginAllowed, mergePublicEnv} = require('../../../public-config.cjs');
export const publicConfig = __PUBLIC_CONFIG__;
export const integrationsEnabled = publicConfig.integrationsEnabled;
export const analyticsEnabled = publicConfig.analyticsEnabled;
export const assetUrl = (path) => joinBase(publicConfig.assetBaseUrl, path);
export const goodstreamAssetUrl = (path) => joinBase(publicConfig.goodstreamAssetBaseUrl, path);
export const apiUrl = (path) => joinBase(publicConfig.apiBaseUrl, path);
export const isBillingOriginAllowed = (origin) => billingOriginAllowed(origin, window.location.origin, publicConfig);
export const applyPublicConfig = (settings) => mergePublicEnv(settings, publicConfig);

export const isExternalRequestDisabled = (path, method) => externalRequestDisabled(path, publicConfig, method);

export const isPaypalReady = (available) => paypalReady(publicConfig, available);

export {disabledIntegrationResponse};
